<template>
  <div class="comp-snapshot">
    <div class="snapshot-container">
      <img
      v-bind:class="{
        'no-snapshot': !snapshot
      }"
      v-bind:src="snapshot ? snapshot : placeHolderImg"
      class="snapshot-img">
      <div
      v-bind:class="{
        'dark': isOldSnapshot
      }"
      class="snapshot-container-inner-wrapper">
        {{isOldSnapshot ? 'Loading...' : ''}}
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Placeholder from '@/components/placeholder'
export default {
  name: 'comp-snapshot',
  props: {
    snapshot: {
      type: String,
      default: function () {
        return null
      }
    },
    isOldSnapshot: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data: function () {
    return {
      isVisible: false
    }
  },
  created: function () {
    // this.runTest()
  },
  computed: {
    placeHolderImg: function () {
      return Placeholder.image()
    }
  },
  methods: {
    runTest: function () {
      this.isVisible = true
      setTimeout(() => { this.isVisible = false }, 3000)
    }
  }
}
</script>

<style scoped>
.comp-snapshot {
  /* common */
  background-color: #fff;
  color: #333;
  /* size */
  width: 100%;
}

.comp-snapshot .snapshot-container {
  /* common */
  background: hsla(0, 0%, 0%, 1);
  /* position */
  position: relative;
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
}
.comp-snapshot .snapshot-container .snapshot-img {
  /* common */
  opacity: 1;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* size */
  width: 100%;
  height: 100%;
}
.comp-snapshot .snapshot-container .snapshot-img.no-snapshot {
  /* common */
  opacity: 0.2;
}
.comp-snapshot .snapshot-container .snapshot-container-inner-wrapper {
  /* common */
  background-color: hsla(0, 0%, 0%, 0);
  color: #fff;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* size */
  width: 100%;
  height: 100%;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comp-snapshot .snapshot-container .snapshot-container-inner-wrapper.dark {
  /* common */
  background-color: hsla(0, 0%, 0%, 0.9);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/CompSnapshot.vue